import React, { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TrendingUp, Banknote, CreditCard, Receipt, BedDouble, Percent, CalendarX } from "lucide-react";

function Card({ icon: Icon, label, value, accent = "text-forest" }) {
  return (
    <div className="bg-white rounded-2xl border border-gold/10 shadow-soft p-5">
      <Icon className={`w-6 h-6 ${accent}`} />
      <div className="text-2xl font-bold text-forest-deep mt-2">{value}</div>
      <div className="text-xs text-muted-foreground">{label}</div>
    </div>
  );
}

export default function Reports() {
  const [period, setPeriod] = useState("daily");
  const [rest, setRest] = useState(null);
  const [hotel, setHotel] = useState(null);

  useEffect(() => {
    api.get("/reports/restaurant", { params: { period } }).then((r) => setRest(r.data)).catch(() => {});
    api.get("/reports/hotel", { params: { period } }).then((r) => setHotel(r.data)).catch(() => {});
  }, [period]);

  return (
    <div className="p-6 space-y-8">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><h1 className="font-display text-4xl text-forest-deep">Справки</h1><div className="gold-rule w-24 my-3" /></div>
        <Tabs value={period} onValueChange={setPeriod}>
          <TabsList className="bg-cream-muted">
            <TabsTrigger value="daily" data-testid="period-daily">Дневна</TabsTrigger>
            <TabsTrigger value="weekly" data-testid="period-weekly">Седмична</TabsTrigger>
            <TabsTrigger value="monthly" data-testid="period-monthly">Месечна</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {rest && (
        <div>
          <h2 className="text-sm uppercase tracking-wider text-gold-dark mb-3">Ресторант</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            <Card icon={TrendingUp} label="Оборот" value={money(rest.total)} />
            <Card icon={Banknote} label="В брой" value={money(rest.cash)} accent="text-emerald-600" />
            <Card icon={CreditCard} label="С карта" value={money(rest.card)} accent="text-blue-600" />
            <Card icon={Receipt} label="Брой поръчки" value={rest.orders} />
            <Card icon={Receipt} label="Средна поръчка" value={money(rest.average)} accent="text-gold-dark" />
          </div>
          <div className="bg-white rounded-2xl border border-gold/10 shadow-soft p-5 mt-4">
            <h3 className="font-display text-2xl text-forest-deep">Най-продавани продукти</h3>
            <div className="gold-rule w-16 my-3" />
            {rest.top_products.length === 0 ? <p className="text-muted-foreground text-sm">Няма данни</p> : (
              <table className="w-full text-sm">
                <thead className="text-left text-forest"><tr><th className="p-2">Продукт</th><th className="p-2">Брой</th><th className="p-2">Оборот</th></tr></thead>
                <tbody>{rest.top_products.map((p) => (
                  <tr key={p.name} className="border-t border-gold/5"><td className="p-2">{p.name}</td><td className="p-2 font-semibold">{p.qty}</td><td className="p-2">{money(p.revenue)}</td></tr>
                ))}</tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {hotel && (
        <div>
          <h2 className="text-sm uppercase tracking-wider text-gold-dark mb-3">Хотел</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <Card icon={TrendingUp} label="Приход от стаи" value={money(hotel.revenue)} />
            <Card icon={BedDouble} label="Продадени стаи" value={hotel.rooms_sold} accent="text-blue-600" />
            <Card icon={BedDouble} label="Стайно-нощувки" value={hotel.room_nights} />
            <Card icon={Receipt} label="Резервации" value={hotel.reservations} />
            <Card icon={CalendarX} label="Отказани" value={hotel.cancellations} accent="text-rose-600" />
            <Card icon={Percent} label="Заетост" value={`${hotel.occupancy}%`} accent="text-gold-dark" />
          </div>
          <div className="mt-4"><Card icon={BedDouble} label="Средна цена на стая" value={money(hotel.average_room_price)} /></div>
        </div>
      )}
    </div>
  );
}
